import { schema } from 'normalizr';

const IntermediaryVariableConfigurationSchema = new schema.Entity('intermediaryVariableConfigurations');

export default IntermediaryVariableConfigurationSchema;
